export const filterConfigReportPres = {
  created: {
    title: 'Дата проведения проверки',
    hasSearch: false,
  },

  responsible: {
    title: 'Ответственный',
    searchPlaceholder: '',
    hasSearch: false,
  },
  direction: {
    title: 'Найти направление',
    options: [],
    hasSearch: false,
  },
};

export const initialFilterReportPres = {
  created: { startDate: '', endDate: '' },
  responsible: { selected: [], selectedIds: [], search: '' },
  direction: { selected: [], selectedIds: [], search: '' },
};

export const initialFilterOpenReportPres = {
  created: false,
  responsible: false,
  direction: false,
};
